export default {
  isAuthenticated: ({ user }) => !!user,
  authErrors: ({ errors }) => errors,
  user: ({ user }) => user,
  roles: ({ user }) => user.roles?.map(({ name }) => name),
  isMotor: ({ user }) => user?.u_motor,
};
